// src/modules/app-views/invoices/pages/Init/components/tableColumns/items/itemUnitPriceColumn.jsx
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { Typography } from 'antd';
import translateX from 'utils/translateX';
import financialService from 'services/financialService';
import { resolveItemFontSize } from './index';

const { Text } = Typography;

// *******************************************************************************
// COLUMN FUNCTION
// *******************************************************************************

// Renders the unit price column for item subtables.
// options.size: 'small' (11px, default) | 'middle' (14px)
function itemUnitPriceColumn(options = {}) {
  const { size } = options;
  const fontSize = resolveItemFontSize(size, 11);

  return {
    title: translateX('unit_price_abbr'),
    dataIndex: 'unitPrice',
    width: 120,
    align: 'right',
    sorter: (a, b) => (a?.unitPrice || a?.unitValue || 0) - (b?.unitPrice || b?.unitValue || 0),
    render: (_, item) => {
      const value = item?.unitPrice ?? item?.unitValue;
      return (
        <Text style={{ fontSize }}>
          {value != null ? financialService.formatCurrency(value) : '—'}
        </Text>
      );
    },
  };
}

export default itemUnitPriceColumn;
